// Shared by the Owner Cockpit's Members page (`/app/members`) AND the Front Desk/Manager Members
// screen (`/desk/members`) — the "All/Active/Frozen/Expired" tab set + status-pill mapping is
// identical across all 3 personas per explicit product decision, backed by the same
// `GET /reports/members-by-status` read-model. `status` here is a MEMBERSHIP lifecycle state
// (a member's most recently created membership's own `status` field), not the account-level
// `member.status` (active/inactive) the rest of the app uses for deactivate/reactivate.
export const MEMBER_STATUS_FILTERS = [
  { key: "all", label: "All" },
  { key: "active", label: "Active" },
  { key: "frozen", label: "Frozen" },
  { key: "expired", label: "Expired" },
];

export function membershipStatusPillProps(membershipStatus) {
  if (membershipStatus === "active") return { status: "active", label: "Active" };
  if (membershipStatus === "frozen") return { status: "expiring", label: "Frozen" };
  if (membershipStatus === "expired") return { status: "overdue", label: "Expired" };
  return { status: "overdue", label: "No plan" };
}
